import React from 'react';
import PropTypes from 'prop-types';
import s from './BallInfo.scss';

const getBallType = (runs, wicket, description) => {
  let className = 'no-runs';
  let data = '';

  if (wicket) {
    data = parseInt(runs, 10) > 0 ? `${runs}W` : 'W';
  } else if (description.indexOf('NB') > -1) {
    data = `${description.substr(0, description.indexOf('NB'))}nb`;
  } else if (description.indexOf('WD') > -1) {
    data = `${description.substr(0, description.indexOf('WD'))}wd`;
  } else if (description.indexOf('LB') > -1) {
    data = `${description.substr(0, description.indexOf('LB'))}lb`;
  } else {
    data = runs;
  }

  if (wicket) {
    className = 'wicket';
  } else if (parseInt(runs, 10) === 4 || parseInt(description[0], 10) === 4) {
    className = 'four';
  } else if (parseInt(runs, 10) === 6 || parseInt(description[0], 10) === 6) {
    className = 'six';
  } else if (
    description.includes('NB') ||
    description.includes('LB') ||
    description.includes('WD')
  ) {
    className = 'Extras';
  }

  return {
    className,
    data,
  };
};

const BallInfo = props => {
  // let {
  //   teamName,
  //   // scored,
  // } = props;
  const { wicket, totalRuns, totalWickets, runs, description } = props;
  // teamName = teamName !== undefined ? teamName : '';
  const ballDetail = getBallType(runs, wicket, description);
  return (
    // <div className={`${s['ball-info']} ${s[ballDetail.className]}`}> // TO DO By HEM
    <div className={`${s['ball-info']} ${s[ballDetail.className]}`}>
      <em>{ballDetail.data}</em>
      <div className={s.boxscore}>
        <div>
          <span>Overs</span>
          {props.overs}
        </div>
        <div>
          <span>Score</span>
          {`${totalRuns} - ${totalWickets}`}
        </div>
      </div>
    </div>
  );
};

BallInfo.propTypes = {
  // teamName: PropTypes.string.isRequired,
  // scored: PropTypes.string.isRequired,
  wicket: PropTypes.number.isRequired,
  totalRuns: PropTypes.string.isRequired,
  totalWickets: PropTypes.string.isRequired,
  runs: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default BallInfo;
